import { PermissionT } from "../types";

export const projectUserUpdates = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "project_user_updates");
  return !!p;
};

export default projectUserUpdates;
